<div class="modal-header">
  <h5 class="modal-title">Send Us a Message</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  @if (!submissionSuccess) {
    <form (ngSubmit)="send()" #contactForm="ngForm">
      <div class="mb-3">
        <textarea
          class="form-control"
          name="message"
          [(ngModel)]="message"
          rows="4"
          placeholder="Type your question or feedback here…"
          required
        ></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="contactForm.invalid || isSending">
          @if(isSending){
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          }
          Send
        </button>
      </div>
    </form>
  } @else {
    <div class="text-center p-4">
      <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem"></i>
      <p class="mt-3 fs-5">Your message has been sent successfully!</p>
      <p class="mt-4">Closing in <strong>{{ redirectTime }}</strong> seconds...</p>
    </div>
  }
</div>
